import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { SystemMessageData } from 'pages/system-messages/system-messages-helper';
import { useQuery, UseQueryResult } from 'react-query';

const fetchSystemMessages = async (
    url: string,
    token: string
): Promise<AxiosResponse<SystemMessageData, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useSystemMessages = (
    props: any
): UseQueryResult<AxiosResponse<SystemMessageData[], any>, unknown> => {
    const { getToken } = useAuth();
    const { daysToReturn } = props;

    const url = `/message?daysToReturn=${daysToReturn}`;
    return useQuery(
        ['system-messages', daysToReturn],
        async () => fetchSystemMessages(url, getToken()),
        {
            cacheTime: 0,
        }
    );
};
